import type { GameCreateRequest, GameDto, GameImportDto, GameTagDto, GameUpdateRequest, GamesListResponse } from '../../api/types';
import type { GamesRepository } from '../../repositories/ApiGamesRepository';

export class GamesService {
  constructor(private readonly repo: GamesRepository) {}

  listGames(params?: { name?: string; tags?: string[] }): Promise<GamesListResponse> {
    return this.repo.listGames(params);
  }

  getGame(params: { gameId: string }): Promise<GameDto> {
    return this.repo.getGame(params);
  }

  createGame(params: { payload: GameCreateRequest }): Promise<GameDto> {
    return this.repo.createGame(params);
  }

  updateGame(params: { gameId: string; payload: GameUpdateRequest }): Promise<GameDto> {
    return this.repo.updateGame(params);
  }

  deleteGame(params: { gameId: string }): Promise<void> {
    return this.repo.deleteGame(params);
  }

  listGameTags(): Promise<GameTagDto[]> {
    return this.repo.listGameTags();
  }

  searchGameTags(params: { query: string }): Promise<GameTagDto[]> {
    return this.repo.searchGameTags(params);
  }

  getFavoriteGames(): Promise<GamesListResponse> {
    return this.repo.getFavoriteGames();
  }

  isGameFavorite(params: { gameId: string }): Promise<boolean> {
    return this.repo.isGameFavorite(params);
  }

  addGameFavorite(params: { gameId: string }): Promise<void> {
    return this.repo.addGameFavorite(params);
  }

  removeGameFavorite(params: { gameId: string }): Promise<void> {
    return this.repo.removeGameFavorite(params);
  }

  importGame(params: { source: string; identifier: string }): Promise<GameImportDto> {
    return this.repo.importGame(params);
  }
}
